import CCColors from '@/Utils/CCColors';
import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {flexDirection: 'row'},
  left: {flex: 0.2, padding: 20},
  center: {flex: 0.5},
  right: {flex: 0.3, padding: 10},
  scrollContainer: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  addNewBox: {
    width: '100%',
    padding: 10,
    borderRadius: 20,
    borderWidth: 1.5,
    borderColor: '#EAE2D5',
    backgroundColor: '#FFFFFF',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    gap: 6,
    transitionProperty: 'all',
    transitionDuration: '0.2s',
  },
  participantsName: {
    paddingVertical: 10,
    paddingHorizontal: 12,
    marginHorizontal: 10,
    marginVertical: 4,
    borderRadius: 12,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderWidth: 1.5,
    borderColor: '#F4EFE6',
    backgroundColor: '#FFFFFF',
    shadowColor: '#000000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.015,
    shadowRadius: 4,
    elevation: 1,
    transitionProperty: 'all',
    transitionDuration: '0.2s',
    transitionTimingFunction: 'ease-in-out',
  },
  unselectedName: {
    backgroundColor: '#FFFFFF',
    borderColor: '#F4EFE6',
  },
  hoveredName: {
    backgroundColor: '#FFFDF6',
    borderColor: '#EAE2D5',
  },
  selectedName: {
    backgroundColor: '#FFFDF6',
    borderColor: '#FACF47',
    borderLeftWidth: 3,
    borderLeftColor: '#FACF47',
    shadowColor: '#FACF47',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.08,
    shadowRadius: 6,
    elevation: 2,
  },
  rowLeading: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    flex: 1,
    marginRight: 8,
  },
  chapterAvatar: {
    width: 22,
    height: 22,
    borderRadius: 11,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FAF6EE',
    borderWidth: 1,
    borderColor: '#EAE2D5',
  },
  chapterAvatarSelected: {
    backgroundColor: '#2C1A11',
    borderColor: '#2C1A11',
  },
  chapterAvatarText: {
    fontSize: 10.5,
    fontWeight: 'bold',
    color: '#757575',
  },
  chapterAvatarTextSelected: {
    color: '#FACF47',
  },
  actionsRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 2,
  },
  actionButton: {
    width: 26,
    height: 26,
    borderRadius: 7,
    alignItems: 'center',
    justifyContent: 'center',
    transitionProperty: 'background-color',
    transitionDuration: '0.15s',
  },
  stickyButtonWrapper: {
    padding: 14,
    paddingTop: 10,
    backgroundColor: '#FFFFFF',
    borderTopWidth: 1,
    borderTopColor: '#EAE2D5',
  },
  syncRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 8,
    paddingHorizontal: 4,
    borderTopWidth: 1,
    borderTopColor: '#EAE2D5',
    marginTop: 8,
  },
});
